import { createApp } from 'vue'
import App from './App.vue'
import './assets/style.css'
import { startHeightReporting } from './embedHeight.js'

// FontAwesome-importer
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrash, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import digitsOnly from './directives/digitsOnly.js'

// Lägg till ikoner i biblioteket
library.add(faTrash, faChevronUp, faChevronDown)

const app = createApp(App)

// Registrera komponent globalt
app.component('font-awesome-icon', FontAwesomeIcon)

// v-digits / v-digits:phone – släpper bara igenom siffror i mm- och nummerfält
app.directive('digits', digitsOnly)

app.mount('#app')

// Låt föräldersidan växa iframen när formuläret ändrar höjd.
startHeightReporting()
